import { useState } from 'react';
import styled from 'styled-components';
import { useDropzone } from 'react-dropzone';
import graphic from './upload-graphic.png';
import { FilePickerButton } from '../FilePickerButton';
import { useUploadContext } from '../useUploadContext';

const Graphic = styled.div`
  background-image: url(${graphic});
  background-position-x: ${(props) => (props.isDragActive ? '-156px' : 0)};
  background-repeat: no-repeat;
  background-size: 200%;
  height: 120px;
  width: 156px;
`;

const DropZone = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.color.grey100};
  color: ${({ theme }) => theme.color.grey900};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 30px 0;
  width: 100%;

  :focus {
    outline: none;
  }
`;

const DropzoneText = styled.p`
  color: ${({ theme }) => theme.color.grey700};
  font-size: 15px;
  max-width: 400px;
  text-align: center;
`;

export const GraphicDropZone = ({
  uploadContainerId,
  mediaGroupId,
  onFilesReceived = () => {},
  style = {},
}) => {
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const { updateQueue } = useUploadContext(uploadContainerId);
  const { getRootProps, isDragActive } = useDropzone({
    onDrop: (files) => {
      updateQueue(files, { mediaGroupId });
      onFilesReceived();
    },
  });

  const { onClick, tabIndex, ...rootProps } = getRootProps();

  return (
    <DropZone
      style={style}
      data-testid="drop-container"
      isDragActive={isDragActive}
      {...rootProps} // eslint-disable-line react/jsx-props-no-spreading
    >
      <FilePickerButton
        inputId={1}
        mediaGroupId={mediaGroupId}
        appearance="link"
        onFilesReceived={onFilesReceived}
        onHoverIn={() => setIsButtonHovered(true)}
        onHoverOut={() => setIsButtonHovered(false)}
        text="browse for a file"
        tabIndex={-1}
        uploadContainerId={uploadContainerId}
      >
        <Graphic isDragActive={isDragActive || isButtonHovered} />
      </FilePickerButton>

      <DropzoneText>
        Drag and drop to upload, or&nbsp;
        <FilePickerButton
          inputId={2}
          mediaGroupId={mediaGroupId}
          appearance="link"
          onFilesReceived={onFilesReceived}
          onHoverIn={() => setIsButtonHovered(true)}
          onHoverOut={() => setIsButtonHovered(false)}
          text="browse for a file"
          uploadContainerId={uploadContainerId}
        />
      </DropzoneText>

      {/*
        FilePickerButton is already hooked up to uploadContext, so we don't
        need an `updateQueue` call here
        */}
    </DropZone>
  );
};
